<template lang="pug">
//- 精緻團班
.group-index.page-index
  //- 內容 TOP (內有 搜尋bar 及 通知區塊 )
  ContentTop
  .group-title 精緻團班

  .row.group-content
    .group-content-left.padding-right-none
      .group-main
        //- 日期組件
        DateCom(
          use_type="group",
          :date_turn="date_turn",
          :date_filter="date_filter",
          @dateTurn="dateTurn",
          @setDate="setCourseDate"
        )
    .group-content-right.padding-none
      //- 篩選器
      FilterCom(
        :language_filter="language_filter",
        :class_filter="class_filter",
        @setLang="setCourseLange",
        @setCourse="setCourseType",
        use_type="group"
      )

  //- 團班課表
  GroupTimeTableArea(
    :language_filter="language_filter",
    :class_filter="class_filter",
    :date_filter="date_filter"
  )
</template>
<script>
// import $ from 'jquery'
import ContentTop from '@/components/content-top/content-top'
import DateCom from '@/components/date'
import FilterCom from '@/components/filter'
import GroupTimeTableArea from '@/components/group/group-timetable-area'
export default {
  coures_teacher: {
    name: 'Index',
  },
  components: {
    ContentTop,
    DateCom,
    FilterCom,
    GroupTimeTableArea
  },
  data () {
    return {
      //- 日期開關
      date_turn: false,
      //- 語言篩選狀態
      language_filter: "all",
      //- 課程篩選狀態
      class_filter: "",
      //- 日期篩選狀態
      date_filter: this.$root.common.getNowTime('date')
    };
  },
  async created () {
    this.$root.closeLoading()
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    // 處理週曆狀態
    dateTurn () {
      this.date_turn = !this.date_turn
    },
    // 設定課程語言
    setCourseLange (_langID) {
      this.language_filter = _langID
    },
    // 設定課程類別
    setCourseType (_courseType) {
      this.class_filter = _courseType
    },
    // 設定課程日期
    setCourseDate (_courseDate) {
      this.date_filter = _courseDate
    }
  }
}
</script>
<style lang="sass">
</style>
